@if (SelectedFolder) {
  <div class="photos-container">
    <button (click)="goBack()" class="back-button">← Back</button>
    <h1>{{SelectedFolder()[0]}}</h1>
    <div class="photos-grid">
      @for (pic of SelectedFolder(); track pic; let i = $index) {
        <div style="display: inline-block">
          @if (i > 0 && pic.indexOf('.mp4') > -1) {
            <video controls>
              <source src="assets/Gallery/{{SelectedFolder()[0]}}/{{pic}}" type="video/mp4">
            </video>
            <div style="margin-left: 25px">{{pic}}</div>
          }
          @if (i > 0 && pic.indexOf('.mp4') === -1) {
            <a title="{{pic}}">
                <img src="assets/Gallery/{{SelectedFolder()[0]}}/{{pic}}" onclick="window.open(this.src)"/>
            </a>
          }
          @if (i > 0 && pic.indexOf('.') === -1) {
            <div class="gallery-tile" (click)="openPhotos(pic)"></div>
          }
          
        </div>
      }
    </div>
  </div>
}

